// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"385":"f890971e","655":"3b7f0954","706":"a6e6be9d"}[chunkId] + ".css";
};